module.exports = __webpack_public_path__ + "static/media/foresting.77bd6aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/foresting.png
// module id = 1866
// module chunks = 146